import { defineArticleAssets } from "@th-m/blogs/mdx";

export default defineArticleAssets({
  "access-maneuver-figure": { kind: "figure", label: "Access Maneuver Figure", tags: ["article-figure", "mdx-component"] },
  "evidence-bridge-figure": { kind: "figure", label: "Evidence Bridge Figure", tags: ["article-figure", "mdx-component"] },
  "logic-plate": { kind: "figure", label: "Logic Plate", tags: ["article-figure", "mdx-component"] },
  "theory-dilemma-figure": { kind: "figure", label: "Theory Dilemma Figure", tags: ["article-figure", "mdx-component"] },
});
